import React from 'react';
import {Multilingual, TextInput, LongTextInput, CheckBox } from 'hyperdb-utils';

const MultilingualTextInput = Multilingual(TextInput);
const MultilingualLongTextInput = Multilingual(LongTextInput);

const PresentationTab = ({ objectData, onChange, availableLocales }) => {
  const handleChangeLocalized = (attributeName, field) => {
    const { name, value } = field;
    onChange(attributeName, { value: { $i18n: value } });
  };
  return (
    <div>
      <fieldset>
        <TextInput
          label="Name *"
          name="name"
          value={ objectData.name }
          onChange={ onChange.bind(null, 'name') }
        />
        <MultilingualTextInput
          label="Headline *"
          name="headline"
          value={ objectData.headline.$i18n }
          onChange={ handleChangeLocalized.bind(null, 'headline') }
          availableLocales={ availableLocales }
        />
        <MultilingualLongTextInput
          label="Summary *"
          name="summary"
          value={ objectData.summary.$i18n }
          onChange={ handleChangeLocalized.bind(null, 'summary') }
          availableLocales={ availableLocales }
        />
        <MultilingualLongTextInput
          label="Description *"
          name="description"
          value={ objectData.description.$i18n }
          onChange={ handleChangeLocalized.bind(null, 'description') }
          availableLocales={ availableLocales }
        />
      </fieldset>
    </div>

  );
};

export default PresentationTab;



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/components/PropertyEditor/PresentationTab.jsx